import { environment } from '../../environments/environment';

export function loadGoogleApi(): () => Promise<void> {
  return () => {
    return new Promise<void>((resolve, reject) => {
      if (!document.querySelector(`script[src*="maps.googleapis.com"]`)) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}&libraries=places,routes`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject('Google API script failed to load.');
        document.head.appendChild(script);
      } else {
        resolve();
      }
    });
  };
}